import React from 'react';
import TransactionsList from './TransactionsList';
import TransactionDetails from './TransactionDetails';

// Zakladka "Paragony" - lista zrealizowanych transakcji.
// Szkice maja wlasna zakladke na poziomie glownym (PosPage, activeTab="szkice").
const ReceiptsTab = ({
  refreshTrigger,
  currentShift,
  currentLocationId,
  selectedTransactionId,
  selectedTransaction,
  onTransactionSelect,
  onCorrectionClick,
  onFiscalPrint,
  onCloseDetails,
  canPrintCopy,
  canReturn
}) => {
  return (
    <div>
      <div style={{ display: "flex", gap: "15px" }}>
        {/* Lista transakcji - pełna szerokość */}
        <div style={{ flex: "1" }}>
          <TransactionsList
            refreshTrigger={refreshTrigger}
            onTransactionSelect={onTransactionSelect}
            onCorrectionClick={onCorrectionClick}
            locationId={currentLocationId}
            isAdmin={
              (currentShift?.kasjer_login || "admin") === "admin"
            }
            onFiscalPrint={onFiscalPrint}
            canPrintCopy={canPrintCopy}
            canReturn={canReturn}
          />
        </div>

        {/* Szczegóły transakcji - jako modal overlay */}
        <TransactionDetails
          transactionId={selectedTransactionId}
          transactionData={selectedTransaction}
          isOpen={!!selectedTransactionId}
          onClose={onCloseDetails}
          canPrintCopy={canPrintCopy}
        />
      </div>
    </div>
  );
};

export default React.memo(ReceiptsTab);
